import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { CalendarDays, Download, Gift, MapPin } from "lucide-react";
import api from "@/lib/api";

const NEON = "#E3FF00";

export default function EventJoin() {
  const { slug } = useParams();
  const [c, setC] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    api.get(`/public/campaigns/${slug}`).then(({ data }) => { setC(data); if (data.active) localStorage.setItem("mp_campaign", slug); }).catch(() => setErr(true));
  }, [slug]);
  if (err) return <div className="min-h-screen grid place-items-center p-6 text-center" data-testid="event-not-found"><div><h1 className="text-2xl font-bold">Evento non trovato</h1><Link to="/register" className="inline-block mt-4 bg-[#E3FF00] text-neutral-900 font-semibold px-5 py-3 rounded-xl">Registrati comunque</Link></div></div>;
  if (!c) return null;
  const fmt = (d) => (d ? new Date(d).toLocaleDateString("it-IT") : "");
  return (
    <div className="min-h-screen px-5 py-10 sm:py-16" style={{ backgroundColor: NEON }} data-testid="event-join-page">
      <div className="max-w-xl mx-auto">
        <img src="/mypasspartu-logo.png" alt="Mypasspartu" className="h-10 w-auto mb-10" onError={(e) => { e.currentTarget.style.display = "none"; }} />
        <p className="text-sm font-semibold uppercase tracking-[0.18em] text-neutral-900/60">Benvenuto da</p>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-neutral-900 mt-2" data-testid="event-name">{c.name}</h1>
        <div className="flex flex-wrap gap-3 mt-4 text-sm text-neutral-900/70">
          {c.location && <span className="inline-flex items-center gap-1"><MapPin className="h-4 w-4" />{c.location}</span>}
          {c.starts_on && <span className="inline-flex items-center gap-1"><CalendarDays className="h-4 w-4" />{fmt(c.starts_on)}{c.ends_on && c.ends_on !== c.starts_on ? ` – ${fmt(c.ends_on)}` : ""}</span>}
        </div>
        <div className="bg-neutral-900 text-white rounded-3xl p-6 sm:p-8 mt-8">
          {c.active ? <>
            <Gift className="h-8 w-8" style={{ color: NEON }} />
            <h2 className="text-2xl font-bold mt-3" data-testid="event-offer">{c.trial_months} mesi gratis di tutti i servizi</h2>
            <p className="text-white/70 mt-2 text-sm leading-relaxed">Riservato ai partecipanti: i servizi gratuiti restano sempre tuoi, quelli a pagamento li provi gratis per {c.trial_months} mesi. Nessuna carta richiesta adesso.</p>
            <div className="grid sm:grid-cols-2 gap-3 mt-6">
              <Link to="/register?campaign=1" className="text-center font-semibold rounded-xl py-3 text-neutral-900" style={{ backgroundColor: NEON }} data-testid="event-register-btn">Registrati gratis</Link>
              <Link to="/login" className="text-center font-semibold rounded-xl py-3 text-neutral-900" style={{ backgroundColor: NEON }} data-testid="event-login-btn">Ho già un account</Link>
            </div>
          </> : <p className="text-white/80" data-testid="event-closed">Questo evento è concluso. Puoi comunque registrarti con 1 mese di prova gratuita.</p>}
        </div>
        <p className="mt-6 text-sm text-neutral-900/70 flex items-center gap-2"><Download className="h-4 w-4" /> Dopo la registrazione potrai installare l'app sul computer o sul telefono.</p>
      </div>
    </div>
  );
}
